import { useContext } from 'react';
import { makeStyles} from '@ellucian/react-design-system/core';
import { spacing50, spacing40, spacing90, fontSizeSmall } from '@ellucian/react-design-system/core/styles/tokens';
import { useIntl } from 'react-intl';
import MFAContext from './MFAContext';
import { Typography } from '@ellucian/react-design-system/core';
import { FormattedMessage } from 'react-intl';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';

const useStyles = makeStyles({
    name: 'QRCode'
})((theme) => ({
    title: { 
        marginBottom: spacing40
    },
    root: {
        paddingTop: spacing40,
        [theme.breakpoints.down('md')]: {
            marginBottom: spacing40,
        },
    },
    container: {
        paddingLeft: spacing90,
        [theme.breakpoints.down('md')]: {
            paddingLeft: '0',
        },
    },
    wrapper: {
        textAlign: 'justify',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
    },
    qrCode: {
        marginBottom: spacing40,
        marginLeft: spacing50,
        [theme.breakpoints.down('md')]: {
            marginLeft: '0',
        },
    },
    accessCode: {
        marginBottom: spacing40
    },
    otpSecret: {
        [theme.breakpoints.down('md')]: {
            fontSize: fontSizeSmall,
        },
    },
}));

const QRCode = () => {
    const { classes } = useStyles();
    const { formatMessage } = useIntl();
    const { qrCodeInfo } = useContext(MFAContext);

    return (
        <div className={classes.root} role="contentinfo">
            <div className={classes.container}>
                <div className={classes.wrapper}>
                    <Typography className={classes.title}>
                        <HtmlFormattedMessage descriptor={{ id: 'applicationRetrievalQrCodeInstructions' }} />
                    </Typography>

                    <div className={classes.qrCode}>
                        {qrCodeInfo?.qrCodeDataUrl ? <img src={qrCodeInfo?.qrCodeDataUrl} alt={formatMessage({ id: 'invalidQRCodeImgAltText' })}/> : ''}
                    </div>

                    <Typography className={classes.accessCode}>
                        <FormattedMessage id="applicationRetrievalAlternateCodeInstructions" />
                    </Typography>

                    <Typography className={classes.otpSecret}>
                        <strong>{qrCodeInfo?.otpSecret ? `${qrCodeInfo?.otpSecret}` : ''}</strong>
                    </Typography>
                </div>
            </div>           
        </div>
    );
};

export default QRCode;